import { makeObservable, observable, action } from "mobx";

export class StoreTeams {
  teamsSsoToken = null;
  teamsGraphToken = null;
  teamsGraphErrors = null;
  teamsContext = null;
  isLoaded = false;

  constructor(rootStore) {
    this.rootStore = rootStore;
    this.teamsSsoToken = "";
    this.teamsGraphToken = null;
    this.teamsGraphErrors = 0;
    this.teamsContext = null;

    makeObservable(this, {
      isLoaded: observable,
      setIsLoaded: action,
      teamsSsoToken: observable,
      setTeamsSsoToken: action,
      teamsGraphToken: observable,
      setTeamsGraphToken: action,
      teamsGraphErrors: observable,
      setTeamsGraphError: action,
      teamsContext: observable,
      setTeamsContext: action,
    });
  }

  setIsLoaded(loaded) {
    this.isLoaded = loaded;
  }

  setTeamsSsoToken(token) {
    this.teamsSsoToken = token;

    // this.rootStore.setAccessToken(token, "teams", "");
    // let tenantId = token?.tenantId;
    // this.setState({ tenantId: tenantId });
    // this.rootStore.main.setUserTenantId(tenantId);
    // // check for file access
    // const hasFileAccess = this.rootStore.getHasUserFileAccess();
    // if (hasFileAccess) {
    //   console.log("INFO app has file access");
    // } else {
    //   console.log("INFO app has NO file access");
    // }
    // this.rootStore.workbooks.setUserHasFileAccess(hasFileAccess);
  }

  setTeamsGraphToken(token) {
    this.teamsGraphToken = token;
  }

  setTeamsGraphError() {
    this.teamsGraphErrors = this.teamsGraphErrors + 1;
    console.log("ERROR TeamsGraphError", this.teamsGraphErrors);
  }

  setTeamsContext(context) {
    this.teamsContext = context;
  }
}
